module.exports = __webpack_public_path__ + "static/media/bc_arrow.258cb3a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bc_arrow.svg
// module id = 882
// module chunks = 3